// src/services/estoque/EstoqueService.js
import { fetchData } from '../Api';

export const buscarEstoques = async () => fetchData('/Estoque');

export const buscarMovimentacoesEstoque = async (produtoId, dataIni, dataFim) => (
    fetchData('/EstoqueMov', {
        ProdutoId: produtoId,
        dataIni: `${dataIni}T00:00:00`,
        dataFim: `${dataFim}T23:59:59`,
    })
);
